import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { head } from "es-toolkit/array";
import { useState } from "react";
import { useTranslations } from "use-intl";
import { ActionTimeline, ActionTimelineError, ActionTimelineSkeleton } from "../../../../../components/ActionTimeline";
import { PriceChangeModal, PriceChangeWarning } from "../../../../../components/PriceChange";
import { useTrackEvent } from "../../../../../providers/TrackEventProvider";
import { useActionErrors } from "../../../../hooks/useErrors";
import { itemQuantitiesForQuote } from "../../../../utils/itemQuantitiesForQuote";
import { useAcceptOfferQuery } from "../../hooks/useAcceptOfferQuery";
import { AcceptOfferFlowTimeline_quoteFragment } from "./AcceptOfferTimeline.fragment";
export function AcceptOffersTimeline(t0) {
  const $ = _c(25);
  const {
    quote: quoteKey,
    priceValidation,
    applyOptionalCreatorFees,
    onAllActionsCompleted
  } = t0;
  const t = useTranslations("wallet.AcceptOffersTimeline");
  const quote = readFragment(AcceptOfferFlowTimeline_quoteFragment, quoteKey);
  const {
    actions,
    error,
    fetching,
    refetch
  } = useAcceptOfferQuery({
    itemQuantities: itemQuantitiesForQuote(quote),
    applyOptionalCreatorFees
  });
  const actionError = useActionErrors();
  const [userAcknowledgedPriceChange, setUserAcknowledgedPriceChange] = useState(false);
  const [showPriceChangeModal, setShowPriceChangeModal] = useState(false);
  const trackEvent = useTrackEvent();
  let t1;
  if ($[0] !== priceValidation || $[1] !== trackEvent) {
    t1 = () => {
      trackEvent("Inline Price Changed Warning Confirmed", {
        priceValidation,
        flow: "accept-offer"
      });
      setShowPriceChangeModal(true);
    };
    $[0] = priceValidation;
    $[1] = trackEvent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onInlineConfirm = t1;
  let t2;
  if ($[3] !== priceValidation || $[4] !== trackEvent) {
    t2 = () => {
      trackEvent("Modal Price Changed Warning Confirmed", {
        priceValidation,
        flow: "accept-offer"
      });
      setUserAcknowledgedPriceChange(true);
      setShowPriceChangeModal(false);
    };
    $[3] = priceValidation;
    $[4] = trackEvent;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onModalConfirm = t2;
  if (priceValidation.hasPriceChanged && !userAcknowledgedPriceChange) {
    let t3;
    if ($[6] !== onInlineConfirm || $[7] !== priceValidation) {
      t3 = <PriceChangeWarning onContinue={onInlineConfirm} priceValidation={priceValidation} />;
      $[6] = onInlineConfirm;
      $[7] = priceValidation;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    const t4 = showPriceChangeModal && <PriceChangeModal onCancel={() => setShowPriceChangeModal(false)} onConfirm={onModalConfirm} priceValidation={priceValidation} symbol={head(quote.totalPrice.pricePerToken)?.token.symbol} />;
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
      t5 = <>{t3}{t4}</>;
      $[9] = t3;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  if (fetching) {
    let t3;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <ActionTimelineSkeleton count={1} />;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    return t3;
  }
  if (error) {
    let t3;
    if ($[13] !== t) {
      t3 = t("cantAcceptOffer");
      $[13] = t;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t4;
    if ($[15] !== refetch || $[16] !== t3) {
      t4 = <ActionTimelineError message={t3} onRetry={refetch} />;
      $[15] = refetch;
      $[16] = t3;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    return t4;
  }
  if (actionError) {
    let t3;
    if ($[18] !== actionError || $[19] !== refetch) {
      t3 = <ActionTimelineError message={actionError} onRetry={refetch} />;
      $[18] = actionError;
      $[19] = refetch;
      $[20] = t3;
    } else {
      t3 = $[20];
    }
    return t3;
  }
  let t3;
  if ($[21] !== actions || $[22] !== onAllActionsCompleted || $[23] !== refetch) {
    t3 = <ActionTimeline actions={actions} onAllActionsCompleted={onAllActionsCompleted} onReload={refetch} />;
    $[21] = actions;
    $[22] = onAllActionsCompleted;
    $[23] = refetch;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  return t3;
}